import React from 'react';
import './CustomError.css';

const CustomError = () => {
    return (
        <div className="custom-error-container">
            <div className="custom-error-icon">🚫</div>
            <h3 className="custom-error-heading">Error</h3>
            <p className="custom-error-text">
                Something went wrong. Please contact the administrator.
            </p>
            <p className="custom-error-text">Copyright © IQVIA. All rights reserved</p>
        </div>
    );
};

export default CustomError;